import { baseUrl } from "../services/interceptor";

export const policyList = (body) => {
  return baseUrl.post("get/policy/list/csr", body);
};
export const getPolicyDetails = (poilcyNumber) => {
  return baseUrl.get(`get/policy/details?policyNo=${poilcyNumber}`);
};
export const getPolicyInsuredInfo = (poilcyNumber, access) => {
  return baseUrl.get(
    `get/policyAndInsured/info/details?policyNo=${poilcyNumber}&isEndorseMode=${access}`,
  );
};
export const getApprovePolicyList = (body) => {
  return baseUrl.post("get/policy/list/approve", body);
};

export const addNewNote = (body) => {
  return baseUrl.post("insert/policy/info/note", body);
};
export const approvePolicy = (policyId) => {
  return baseUrl.post("approve/policy", policyId);
};
export const updateWarning = (body) => {
  return baseUrl.post("update/policy/info/warnings", body);
};
export const clearedDiaryService = (policyId) => {
  return baseUrl.patch("/update/diary?id=" + parseInt(policyId));
};
export const getPremiumDetails = (poilcyNumber, access) => {
  return baseUrl.get(
    `get/policy/coverage/options?policyNo=${poilcyNumber}&isEndorseMode=${access}`,
  );
};
export const getDocumentList = (body) => {
  return baseUrl.post("get/ImaginingList", body);
};
export const viewPayments = (body) => {
  return baseUrl.post("/get/policy/billing/payment/detail", body);
};
export const getStatusInfo = (poilcyNumber) => {
  return baseUrl.get(`get/policy/info/status?policyNo=${poilcyNumber}`);
};

export const getPolicyIndexAndDesc = (policyNo) => {
  return baseUrl.get(`get/IndexAndDescriptionList?policyNo=${policyNo}`);
};
export const updateSuspense = (body, isSuspenseForPrint) => {
  return baseUrl.post(`update/policy/suspenses`, body);
};
export const updateApReasons = (body) => {
  return baseUrl.post(`update/policy/APReasons`, body);
};
export const downloadDocument = (indexId) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.get(`/download/document?indexID=${indexId}`, headers);
};

export const getForm = (department) => {
  return baseUrl.get(`get/images/list/formType?department=${department}`);
};
export const getCategory = (department) => {
  return baseUrl.get(`get/images/list/category?department=${department}`);
};

export const uploadDocument = (data, body) => {
  return baseUrl.post(
    `upload/document/${data.formDesc}/${data.fileNo}/${data.category}/${data.dept}/${data.formType}`,
    body,
  );
};
export const getActiveUsers = () => {
  return baseUrl.get(`get/active/users`);
};
export const addReminder = (body) => {
  return baseUrl.post(`add/reminder`, body);
};

export const getreminderList = (policyNo) => {
  return baseUrl.get(
    `get/list/diary/byPolicy?policyNo=${policyNo}&isNonClear=true`,
  );
};

export const hideImage = (id) => {
  return baseUrl.patch(`/hide/image?id=${id}`);
};

export const unHideImage = (id) => {
  return baseUrl.patch(`/un-hide/image?id=${id}`);
};

export const sendDocFile = (body) => {
  return baseUrl.post(`/document/sendFileOnEmails`, body);
};
export const updateDocument = (data, body) => {
  return baseUrl.post(
    `update/document/${data.formDesc}/${data.fileNo}/${data.category}/${data.dept}/${data.formType}/${data.indexId}`,
    body,
  );
};

export const getDriverDetails = (policyNo, licenseNo) => {
  return baseUrl.get(
    `get/driver/view/details?policyNo=${policyNo}&licenseNo=${licenseNo}`,
  );
};

export const getVehicleDetails = async (policyNo, vin, isEndorseModeAPI) => {
  return await baseUrl.get(
    `get/vehicle/view/details?policyNo=${policyNo}&vin=${vin}&isEndorseMode=${isEndorseModeAPI}`,
  );
};
export const getDocDetails = (indexId) => {
  return baseUrl.get(`get/document/details?indexId=${indexId}`);
};
export const getVinDetails = (body) => {
  return baseUrl.post(`template/verisk/vin/search/v2`, body);
};
export const getViolationList = (body, isEndorseModeAPI) => {
  return baseUrl.post(
    `/get/list/getViolations?isEndorseMode=${isEndorseModeAPI}`,
    body,
  );
};

export const issueNoticeService = (body) => {
  return baseUrl.post(`/active/issueNotice`, body);
};
export const cancelPolicyService = (body) => {
  return baseUrl.post(`/active/cancelPolicy`, body);
};

export const getDriverListService = (body, isEndorseModeAPI) => {
  return baseUrl.post(
    `get/policy/driver/details?isEndorseMode=${isEndorseModeAPI}`,
    body,
  );
};

export const getCarListService = (body, isEndorseModeAPI) => {
  return baseUrl.post(
    `get/policy/car/details?isEndorseMode=${isEndorseModeAPI}`,
    body,
  );
};

export const driverLicenseValidate = (licenseNo, licenseState, dateOfBirth) => {
  return baseUrl.get(
    `/amend/drivLicense/validation?licenseNo=${licenseNo}&licenseState=${licenseState}&dateOfBirth=${dateOfBirth}`,
  );
};
export const checkHoldService = (body) => {
  return baseUrl.post(`update/policy/holdOrRelease`, body);
};
export const getPolicyHoldStatus = (policy) => {
  return baseUrl.get(`policy/hold/status?policyNo=${policy}`);
};

export const reinstateService = (policyNo) => {
  return baseUrl.post(`active/reinstate?policyNo=${policyNo}`);
};
export const getUWFormsService = (dateUW) => {
  return baseUrl.get(`get/und/forms/details?selectedDate=${dateUW}`);
};

export const getformTypes = (dateUW) => {
  return baseUrl.get(`get/und/formTypes `);
};

export const suspenseFormSubmit = (body) => {
  return baseUrl.post(`add/und/suspenseForm`, body);
};

export const printUWFormsService = (body) => {
  return baseUrl.post(`und/print/generate`, body);
};
export const getGenerateLetterService = (policyNo) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(
    `und/generate/3OptLetter?policyNo=${policyNo}`,
    {},
    headers,
  );
};

export const printDiary = (body) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(`print/diary`, body, headers);
};

export const geneRateEndorseMent = (policyNo) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(
    `und/generate/endorsement?policyNo=${policyNo}`,
    {},
    headers,
  );
};
export const rewritePolicyService = (policyNo) => {
  return baseUrl.get(
    `active/enable/rewrite/button?policyNo=${policyNo}&activate=true`,
  );
};

export const clearReminder = (indexId) => {
  return baseUrl.patch(`update/diary?id=${indexId}`);
};

export const rescind = (policyNo) => {
  return baseUrl.post(
    `active/enable/rescind/button?policyNo=${policyNo}&activate=true`,
  );
};

export const rewriteButtonClickServices = (policyNo) => {
  return baseUrl.post(`active/RewritePolicy/btnClick/?policyNo=${policyNo}`);
};

export const recindesFormView = (policyNo) => {
  return baseUrl.get(`active/RescindPolicy/FormData/?policyNo=${policyNo}`);
};

export const recindePolicyButton = (policyNo) => {
  return baseUrl.post(`active/RescindPolicy/FormButton/?policyNo=${policyNo}`);
};

export const getRatingFactor = (policyNo) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(
    `und/generate/ratingFactor?policyNo=${policyNo}`,
    {},
    headers,
  );
};
export const getClaims = (policyNo) => {
  return baseUrl.get(
    `active/reinstate/openClaims/warning/?policyNo=${policyNo}`,
  );
};

export const getThumbnail = (indexId) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.get(`/get/document/getThumbnail?indexId=${indexId}`, headers);
};

export const hideUnhideHistory = (indexid, isHide) => {
  return baseUrl.post(
    `hideOrUnhide/policy/history?indexID=${indexid}&isHide=${isHide}`,
  );
};
export const getNotesList = () => {
  return baseUrl.get(`/get/system/notes`);
};
export const updateOverrirde = (policyNo, flag) => {
  return baseUrl.post(
    `update/policy/overrideRPPayee?policyNo=${policyNo}&isOverrideRPPayee=${flag}`,
  );
};
export const getDocumentDescList = () => {
  return baseUrl.get(`/get/document/desc`);
};
// App Settings
export const getSettingsReason = (maintainceType) => {
  return baseUrl.post(`/get/maintaince/list?maintainceType=${maintainceType}`);
};

export const addSettingsReason = (body) => {
  return baseUrl.post(
    `/add/maintaince/reason?description=${body.description}&maintainceType=${body.maintainceType}&reasonType=${body.reasonType}`,
  );
};

export const removeSettingsReason = (body, maintainceType) => {
  let data = {
    indexIdList: body,
  };
  return baseUrl.delete(
    `/delete/maintain/reasons?maintainceType=${maintainceType}`,
    { data },
  );
};
export const getPolicyInfo = (policyNo) => {
  return baseUrl.get(`get/policy/search/details?policyNo=${policyNo}`);
};

export const saveBankInfo = (formData) => {
  return baseUrl.post(`save/bankinfo`, formData);
};

export const deleteBankInfo = (body) => {
  return baseUrl.delete(`delete/bankinfo?recordId=${body.policyNumber}`);
};

export const viewPortal = (policy) => {
  return baseUrl.post(`options/view/policyPortalOptions?policyNo=${policy}`);
};

export const savePortalOptions = (body) => {
  return baseUrl.post(`options/update/policyPortalOptions`, body);
};
export const viewBankInfo = (recordId) => {
  return baseUrl.get(`get/bankinfo?recordId=${recordId}`);
};
export const deleteNotes = (noteId) => {
  return baseUrl.delete(`delete/policy/note?noteId=${noteId}`);
};

export const getAllRolePermissions = () => {
  return baseUrl.get(`getRolePermissions`);
};

export const updateRolePermissions = (body) => {
  return baseUrl.post(`UpdatePermissions`, body);
};
export const addPermission = (body) => {
  return baseUrl.post("add/permission", body);
};
export const getRoleService = () => {
  return baseUrl.get(`getRole`);
};
export const getImagingCategories = () => {
  return baseUrl.get(`get/imaging/category`);
};
export const printNotes = (policyNo) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(`print/notes?policyNo=${policyNo}`, null, headers);
};
export const getStateListService = () => {
  return baseUrl.get(`get/state/list`);
};
export const addRole = (body) => {
  return baseUrl.post("add/role", body);
};
export const getReinstateData = (policyNo) => {
  return baseUrl.post(`get/reinstateReason?policyNo=${policyNo}`);
};

export const clickReinstate = (policyNO, indexNumber) => {
  return baseUrl.post(
    `get/newReinstate?policyNo=${policyNO}&indexNumber=${indexNumber}`,
  );
};
export const getPolicyFiles = (type) => {
  let url =
    type === "Claims"
      ? `claim/adhoc/getFiles?type=${type}`
      : `adHoc/getFiles?type=${type}`;

  return baseUrl.get(url);
};

export const getFileDetailsRTF = (type, fileType) => {
  let url =
    fileType === "Claims"
      ? `claim/adhoc/getHtml?fileName=${type}&type=${fileType}`
      : `adHoc/getHtml?fileName=${type}&type=${fileType}`;
  return baseUrl.get(url);
};

export const getPdfRTF = (editorBody, formData, type, fileType, claimNo) => {
  let body = {
    htmlString: editorBody,
    isPolicyNo: formData.isPolicyNo,
    isAgent: formData.isAgent,
    isDefaultHeader: formData.isDefaultHeader,
    policyNo: formData.policyNo,
    isOurInsured: formData.isOurInsured,
    isInsured: !formData.isAgent,
    isIncludeAdjuster: formData.isIncludeAdjuster,
  };
  let agentbody = {
    htmlString: editorBody,
    isPolicyNo: formData.isPolicyNo,
    isAgent: formData.isAgent,
    isDefaultHeader: formData.isDefaultHeader,
    policyNo: formData.policyNo,
    isOurInsured: formData.isOurInsured,
    isInsured: !formData.isAgent,
    agentCode: claimNo,
    isIncludeAdjuster: formData.isIncludeAdjuster,
  };
  let claimsBody = {
    htmlString: editorBody,
    adhocAddressOption:
      formData.adhocAddressOption === "" ? null : formData.adhocAddressOption,
    claimNo: claimNo,
    claimNoHeading: formData.claimNoHeading,
    claimant: formData.claimant,
    claimantIndex: formData.claimantIndex,
    dateOfLoss: formData.dateOfLoss,
    defaultHeader: formData.isDefaultHeader,
    dlNo: formData.dlNo,
    includeAdjuster: formData.isIncludeAdjuster,
    ourClaimNumber: formData.ourClaimNumber,
    ourInsured: formData.isOurInsured,
    policyNo: formData.isPolicyNo,
  };
  let headers = {
    responseType: "blob",
  };
  let url =
    fileType === "Claims"
      ? `claim/adhoc/getAdhocPreview?isSave=${type}`
      : fileType === "Agent"
      ? `agent-csr/adhoc/getAdhocPreview?isSave=${type}`
      : `adHoc/getAdhocPreview?isSave=${type}`;
  return baseUrl.post(
    url,
    fileType === "Policy"
      ? body
      : fileType === "Agent"
      ? agentbody
      : claimsBody,
    headers,
  );
};
export const updateBankInfo = (formData) => {
  return baseUrl.post(`options/update/bank/info`, formData);
};

export const saveAdhocLetter = (htmlString, fileName, fileType) => {
  let body = {
    type: fileType,
    fileName: fileName,
    htmlString: htmlString,
  };
  let url =
    fileType === "Claims"
      ? `claim/adhoc/getSaveHtmlTemplate`
      : fileType === "Agent"
      ? `agent-csr/adhoc/getSaveHtmlTemplate`
      : `adHoc/getSaveHtmlTemplate`;
  return baseUrl.post(url, body);
};

export const getAdhocaddressService = (claimNo, claimantIndex, policyNo) => {
  return baseUrl.get(
    `claim/adhoc/address?claimNo=${claimNo}&claimant=${claimantIndex}&policyNo=${policyNo}`,
  );
};

export const getNoteListServices = (policyNo) => {
  let body = {
    pagination: { currentPage: 0, pageSize: 15 },
    search: [{ criteriaName: "policyNo", value: policyNo }],
    sort: { columnName: "date", orderBy: "DESC" },
  };
  return baseUrl.post(`get/policy/notes/details`, body);
};

export const getPrint = (processId) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.get(`und/print/getPrint?processId=${processId}`, headers);
};

export const getPrintStatus = (processId) => {
  return baseUrl.get(`und/print/printForm/status?processId=${processId}`);
};

export const sweepAgentApi = (policyNo, amount) => {
  let headers = {
    responseType: "blob",
  };
  return baseUrl.post(
    `agent/sweep/payment?policyNo=${policyNo}&amount=${amount}`,
    null,
    headers,
  );
};

export const checkSweepValidate = (policyNo, amount) => {
  return baseUrl.get(
    `validate/sweep/payment?policyNo=${policyNo}&amount=${amount}`,
  );
};
export const checkProcessNewPayment = (policyNo, amount) => {
  return baseUrl.get(
    `validate/processNewPayment?policyNo=${policyNo}&amount=${amount}`,
  );
};
export const getPremiumDetailsService = (policyNo, aDate) => {
  return baseUrl.get(
    `policy/endorse/paymentSchedule?policyNo=${policyNo}&amendDate=${aDate}`,
  );
};
export const getApproveEndorsementPolicy = (id) => {
  return baseUrl.post(`update/policy/endorseApproval?indexIdList=${id}`, {});
};

export const getApprovePipbills = (id) => {
  return baseUrl.get(`claim/pipLog/approve?indexIds=${id}`);
};
